// a function that will work like the normal JS .replaceAll() that will work for older browsers
export default function replaceAllCompat(text: string, textToFind: string, textToInsert: string) {
	return text.replace(new RegExp(escapeRegExp(textToFind), "g"), textToInsert);
}

// Best practice from MSDN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
function escapeRegExp(text: string) {
	return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}
